import { BrowserTracing } from '@sentry/tracing'
import * as Sentry from '@sentry/vue'
import BootstrapVue from 'bootstrap-vue'
import PortalVue from 'portal-vue'
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueDateFns from 'vue-date-fns'
import { createDateFilter } from 'vue-date-fns'
import { VueMasonryPlugin } from 'vue-masonry'
import VueMeta from 'vue-meta'
import VueRouter from 'vue-router'
import VueSilentbox from 'vue-silentbox'
import Vuelidate from 'vuelidate'
import WOW from 'wow.js/dist/wow.js'

import App from './App.vue'
import store from './store'

Vue.use(Vuelidate)
Vue.use(PortalVue)
Vue.use(VueMasonryPlugin)
Vue.use(VueSilentbox)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
})
Vue.use(VueDateFns)

import 'bootstrap/dist/css/bootstrap.css'
import '../src/assets/css/fontawesome-all.min.css'
import 'swiper/dist/css/swiper.css'
import 'animate.css/animate.min.css'
import '../src/assets/scss/style.scss'
import 'slick-carousel/slick/slick.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false
Vue.config.productionSourceMap = false
Vue.filter('dateWithTime', createDateFilter('MM/dd/yyyy hh:mm a'))

import { routes } from './router/index'

const router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

Sentry.init({
  Vue,
  dsn: 'https://d119b09cfdb54a858197045f1fe8c8ab@o1121159.ingest.sentry.io/6315742',
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  release: 'pxl-games-website@' + require('../package.json').version,
  environment: process.env.VUE_APP_ENV,
  tracesSampleRate: 1.0,
})

new Vue({
  render: (h) => h(App),
  router,
  store,
  mounted() {
    new WOW().init()
  },
}).$mount('#app')
